import * as React from 'react';

interface ArrowIconProps {
    color?: string;
    rotation?: number;
}

const ArrowIcon: React.FC<ArrowIconProps> = ({ color = 'var(--primary-color)', rotation }: ArrowIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="31" viewBox="0 0 33 31">
            <g
                fill="none"
                fillRule="evenodd"
                stroke={color}
                strokeWidth="2"
                transform={rotation && `rotate(${rotation}, 16, 15)`}
            >
                <path strokeLinecap="square" d="M.84 15.5h29"></path>
                <path d="M18.965 29.852l12.688-14.078L18.965 1.148"></path>
            </g>
        </svg>
    );
};

export default React.memo(ArrowIcon);
